export enum LoanType {
  NordeaLoan = 'nordealoan',
  NordeaLeasing = 'nordealeasing',
  Ecster = 'ecster',
  Moank = 'moank',
}
